<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card :title="'CATEGORY LIST'" class="">
        <template slot="actions">
          <vs-button v-can="'create-edit-other-suppliers'"  @click.stop="onClickAdd" icon-pack="feather" icon="icon-plus" class="mr-4" color="primary"
                     type="filled">create
          </vs-button>
        </template>
        <div id="category-table" class="vx-row">
          <div class="w-full vx-col">

            <vs-table stripe sort class="mt-8" :data="categories">
              <template slot="thead">
                <vs-th width="25%">Category Name</vs-th>
                <vs-th width="40%">Description</vs-th>
                <vs-th width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr"
                       v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].description">
                    {{ data[indextr].description }}
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="justify-start vx-row">
                      <vx-tooltip v-can="'create-edit-other-suppliers'" text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr].id)" class="ml-3"
                                   size="small" color="warning" type="border" icon-pack="feather"
                                   icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'delete-other-supplier-services-&-categories'" text="Remove" position="left">
                        <vs-button @click.stop="openConfirm(data[indextr].id)" class="ml-3"
                                   size="small" color="danger" type="border" icon-pack="feather"
                                   icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>

          </div>
        </div>
      </vx-card>
    </div>
    <create-other-supplier-category-pop-up ref="createOtherSupplierCategoryPopUp"/>
  </div>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory';
import CreateOtherSupplierCategoryPopUp
  from "@/components/popups/other-suppliers/category/CreateOtherSupplierCategoryPopUp";
import Filter from '@/mixins/filter';
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import {defaultPagination, perPageList} from "@/constants/config";

const OtherSupplierRepository = RepositoryFactory.get('other_supplier');

export default {
  name: "OtherSupplierCategoryManage",
  data() {
    return {
      categories: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
    }
  },
  components: {
    CreateOtherSupplierCategoryPopUp
  },
  methods: {
    async refreshData() {
      await this.fetchCategories()
    },
    async fetchCategories() {
      await this.$vs.loading({
        container: '#category-table',
        scale: 0.45
      })
      const {data} = await OtherSupplierRepository.getAllCategoryList()
      this.categories = data.data
      this.meta = data.meta
      this.$vs.loading.close('#category-table > .con-vs-loading')
    },
    async onClickAdd() {
      await this.$refs.createOtherSupplierCategoryPopUp.openPopup()
    },
    async onClickUpdate(id) {
      await this.$refs.createOtherSupplierCategoryPopUp.openPopup(id)
    },
    openConfirm(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm`,
        text: 'Are you sure you want to delete this ?',
        accept: this.onClickDelete,
        parameters: [id]
      })
    },
    async onClickDelete(params) {
      try {
        await OtherSupplierRepository.deleteCategory(params[0])
        await this.fetchCategories()
        await this.showSuccessMessage('Category Deleted!');
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    filterQueryUpdate() {
      this.fetchCategories()
    },

    handleChangePage(page) {
      this.page = page;
      this.fetchCategories()
    },
    handleSort(key, active) {
      if (key) {
        active = (active === 'desc') ? "-" : '';
        this.sort = active + key;
        this.fetchCategories()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
  },
  async mounted() {
    await this.fetchCategories()
  },
  mixins: [Filter, SuccessMessage, ErrorMessages],
  watch: {
    page() {
      this.fetchCategories()
    },
    perPage() {
      this.fetchCategories()
    }
  }
}
</script>

<style scoped>

</style>
